<template>
    <button class="tile-button">
        <slot />
    </button>
</template>

<script>
export default {

}
</script>

<style lang="sass" scoped>
@import '../../../../styles/global-variables'

.tile-button
    @include tile-button
</style>